
















import { Vue, Component } from 'vue-property-decorator';
import { workShow } from '../api/img';
import { scenePic } from '../api';
import { ImagePreview, Toast } from 'vant';
@Component
export default class PicShow extends Vue {
  activeIndex = 0;
  images = [];
  get activeImages() {
    return this.images.slice(this.activeIndex * 4, this.activeIndex * 4 + 4);
  }
  get maxIndex() {
    return Math.ceil(this.images.length / 4);
  }

  async created() {
    const res = await scenePic();
    this.images = res.data;
    console.log(res);
  }
  showPic(index: number) {
    ImagePreview({
      images: this.images,
      startPosition: this.activeIndex * 4 + index,
    });
  }

  _handleLeft() {
    if (this.activeIndex === 0) {
      return Toast('点击向右查看更多~');
    }
    this.activeIndex--;
  }
  _handleRight() {
    // 到最大的索引 直接return
    if (this.activeIndex === this.maxIndex - 1) {
      return Toast('点击向左查看更多~');
    }
    this.activeIndex++;
  }
}
